import { useQuery } from "@tanstack/react-query";
import * as api from "@/services/inventory_api";

export function useInventorySuppliers(search?: string) {
  return useQuery({
    queryKey: ["inventory", "suppliers", search ?? null],
    queryFn: () => api.listSuppliers(search),
    staleTime: 60_000,
  });
}

export function useInventorySupplierCatalogNos(
  supplierId: number | null,
  search?: string,
) {
  return useQuery({
    queryKey: ["inventory", "suppliers", supplierId, "catalog-nos", search ?? null],
    enabled: supplierId !== null,
    queryFn: () => api.listSupplierCatalogNos(supplierId!, search),
    staleTime: 60_000,
  });
}
